import * as React from 'react';

/**
 * The compliance queue's search box (SR-466), read as typed, as the SEC ADV register's: the address
 * follows the draft, trimmed, 250 ms after the last key, and Enter sends it at once; an address that
 * moves (Back, Clear) resets the draft — but not the draft that sent it, whose trailing space a
 * typist may be about to follow with a word. The timer calls the newest `onSearch`, not the one of the
 * render that typed: a router's `setParams` closes over the address it rendered with, so the old one
 * would write back a filter or a tab changed while the timer ran.
 */
export function useQueueSearch(q: string, onSearch: (text: string) => void) {
  const [draft, setDraft] = React.useState(q);
  const latest = React.useRef(onSearch);
  latest.current = onSearch;
  React.useEffect(() => setDraft((typed) => (typed.trim() === q ? typed : q)), [q]);
  React.useEffect(() => {
    if (draft.trim() === q) return;
    const timer = setTimeout(() => latest.current(draft.trim()), 250);
    return () => clearTimeout(timer);
  }, [draft, q]);
  return { draft, onDraft: setDraft, onSubmit: () => onSearch(draft.trim()) };
}
